import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import { LoginSuccessfully, SuccessMessageTitle } from "../../../../Constants/Constants";
import { SuccessMessageSubTitle } from "../../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SuccessMessage = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "Good job!",
      text: "You clicked the button!",
      icon: "success",
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={SuccessMessageTitle} span={SuccessMessageSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="success" className="sweet-8" onClick={handleAlert}>
            {LoginSuccessfully}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default SuccessMessage;
